import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { archiveCohort } from 'Workspace/Cohorts/store/actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { cohortId } = action;

  const workspaceCohortArchive = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_ARCHIVE,
    cohortId,
  });

  if (workspaceCohortArchive.type === constants.RTM_WORKSPACE_COHORT_ARCHIVE_OK) {
    const finishedDate = workspaceCohortArchive.response.finishedDate;
    yield put(archiveCohort(cohortId, finishedDate));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspaceCohortArchive.message || <FormattedMessage {...messages.cohortArchiveError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_ARCHIVE, catchErrors, sendRequest, connection);
}
